import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0354a0f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "alert alert-danger text-center",
    id: "alerta-erro-conta"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "bg-container" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("b", null, "CLIQUE AQUI PARA CORRIGIR.", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.resumoFinanceiro && _ctx.resumoFinanceiro.ultimo_saque_voltou_com_erro === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", {
                class: "texto pointer",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.abrirModalDadosBancarios()))
            }, [
                _createTextVNode(" Não conseguimos realizar o depósito na conta cadastrada."),
                _hoisted_3,
                _createTextVNode(" Lembre-se que só é possível receber as doações em contas vinculadas ao CPF/CNPJ do titular da campanha."),
                _hoisted_4,
                _hoisted_5
            ])
        ]))
        : _createCommentVNode("", true);
}
